import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { useBackgroundContext } from '../contexts/BackgroundContext';
import LightSource from '../components/animations/LightSource';
import BlurredLines from '../components/animations/BlurredLines';
import BlurryBubbles from '../components/animations/BlurryBubbles';
import ChampagneBubbles from '../components/animations/ChampagneBubbles';
import Fireworks from '../components/animations/Fireworks';
import SolidColor from '../components/animations/SolidColor';

import { TAppElkBackgroundAnimation } from 'TProtocol/prototypes/events/messages';

const AnimationBackground = () => {
  const backgroundContext = useBackgroundContext();
  const animation = backgroundContext.animation;

  let animationNode: ReactNode;
  switch (animation) {
    case undefined:
      animationNode = <SolidColor/>;
      break;
    case TAppElkBackgroundAnimation.BLURRED_LINES:
      animationNode = <BlurredLines/>;
      break;
    case TAppElkBackgroundAnimation.BLURRY_BUBBLES:
      animationNode = <BlurryBubbles/>;
      break;
    case TAppElkBackgroundAnimation.CHAMPAGNE_BUBBLES:
      animationNode = <ChampagneBubbles/>
      break;
    case TAppElkBackgroundAnimation.COSMIC:
      // TODO: this one isn't done yet, the example was way too complicated
      animationNode = <LightSource/>;
      break;
    case TAppElkBackgroundAnimation.FIREWORKS:
      animationNode = <Fireworks/>;
      break;
    case TAppElkBackgroundAnimation.LIGHT_SOURCE:
      animationNode = <LightSource/>;
      break;
    case TAppElkBackgroundAnimation.OIL_ON_WATER:
      // TODO: this one isn't done yet, we need to generate the image somehow
      animationNode = <LightSource/>;
      break;
    default:
      const exhaustiveCheck: never = animation;
      throw new Error(`Unhandled field type: ${exhaustiveCheck}`);
  }

  return <AnimationContainer>
    {animationNode}
  </AnimationContainer>;
};


const AnimationContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

export default AnimationBackground;
